
import styles from './contactsPage.module.css';
import { MarkupLayout } from '../../components/ui/markupLayout/MarkupLayout';
import { MapComponent } from '../../components/mainPage/contactsSection/map/Map';
import { useDialogStore } from '../../module/modal-container/stores/useDialogStore';
import { Button } from '../../components/ui/button/Button';
export function ContactsPage() {
  const openDialog = useDialogStore((state) => state.openDialog);
  return (
    <MarkupLayout>
      <section className={styles.container}>
        <div className={styles.contactsSection}>
          <div className={styles.headerWrapper}>
            <h1 className={styles.title}>Контакты</h1>
          </div>
          <nav>
            <ul className={styles.contactList}>
              <li>
                <a href="https://t.me/sct_germany" target="_blank" rel="noopener noreferrer">
                  <img
                    className={styles.icon}
                    src="/images/contactsPage/telegram.webp"
                    alt="Telegram"
                  />
                </a>
              </li>
              <li>
                <a href="tel:+74992882648">
                  <img className={styles.icon} src="/images/contactsPage/call.webp" alt="Телефон" />
                </a>
              </li>
              <li>
                <a className={styles.phone} href="tel:74992882648">
                  7 499 288-26-48
                </a>
              </li>
              <li>|</li>
              <li>
                <a className={styles.mail} href="mailto:info@sct-germany.ru">
                  info@sct-germany.ru
                </a>
              </li>
            </ul>
          </nav>


        </div>


        <div className={styles.infoSection}>
          <div className={styles.info}>
            <p className={styles.info_address}>111673, г. Москва, ул. Салтыковская, д. 8</p>
            <p>
              <a href="mailto:info@sct-germany.ru">
                info@sct-germany.ru
              </a>
            </p>
            <p>
              <a href="tel:+74952282648" >
                +7 495 228-26-48
              </a>
            </p>
          </div>
          <Button variant={"yellow"} width={"w-310"} onClick={() => openDialog('partner')}>Как стать партнером</Button>
          <div style={{ maxWidth: 310 }}>
            <Button title="по вопросам качества и технической поддержки" variant={"yellow"} onClick={() => openDialog('quality')}>Техническая поддержка</Button>
          </div>
        </div>


        <div className={styles.mapSection}>
          <MapComponent />
        </div>
      </section>
    </MarkupLayout>
  );
}
/* <div className={styles.cardsSection}>
        <article className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardIconWrapper}>
              <img
                className={styles.cardIcon}
                src="/images/contactsPage/region-stores.webp"
                alt="Розничные точки продаж"
              />
            </div>
            <h2>Розничные точки продаж</h2>
          </div>
          <List listItems={listItems} />
        </article>
        <article className={styles.card}>
          <div className={styles.cardHeader}>
            <div>
              <img
                className={styles.cardIcon}
                src="/images/contactsPage/dillers.webp"
                alt="Региональные представители"
              />
            </div>
            <h2>Региональные представители</h2>
          </div>
          <List listItems={listItems} />
        </article>
      </div> */